<h1 class="page-title mb-5">الإستثمار الداخلي </h1>
<div>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-9">
                <p>
                    <strong>الاستثمار الداخلي</strong> هو أحد نظم الاستثمار يتم من خلاله
                    إقامة أو إنشاء أو تشغيل مشروع استثماري وفقاً لأحكام قانون الاستثمار
                    رقم 72 لسنة 2017 ، في غير المناطق الحرة .
                </p>
                <p>
                    تتمتع جميع المشروعات الاستثمارية الخاضعة لأحكام هذا القانون، سواء
                    المقامة قبل العمل بأحكامه أو بعده، أياً كان النظام القانوني الخاضعة
                    له، بالحوافز العامة الواردة في هذا الفصل، وذلك فيما عدا المشروعات
                    المقامة بنظام المناطق الحرة .
                </p>

                <div style="
            background-color: var(--color-gafi-border);
            border-right: 5px var(--color-primary) solid;
          " class="mb-4">
                    <p style="font-size: 16px; color: var(--color-gray-444)" class="p-2">
                        الحوافز والضمانات
                    </p>
                </div>

                <h5>أولا :ضمانات الاستثمار:</h5>
                <ol>
                    <li>
                        تتمتع جميع الاستثمارات المقامة في جمهورية مصر العربية بالمعاملة
                        العادلة والمنصفة.
                    </li>
                    <li>
                        تكفل الدولة للمستثمر الأجنبي معاملة مماثلة لتلك التي تمنحها للمستثمر
                        الوطني، ويجوز استثناء بقرار من مجلس الوزراء تقرير معاملة تفضيلية
                        للمستثمرين الأجانب تطبيقاً لمبدأ المعاملة بالمثل.
                    </li>
                    <li>
                        لا تخضع الأموال المستثمرة لأي إجراءات تعسفية أو قرارات تتسم
                        بالتمييز.
                    </li>
                    <li>
                        تمنح الدولة المستثمرين غير المصريين إقامة في جمهورية مصر العربية
                        طوال مدة المشروع، وذلك دون الإخلال بأحكام القوانين المنظمة لذلك .
                    </li>
                    <li>
                        تلتزم الدولة باحترام وإنفاذ العقود التي تبرمها ولا يتمتع المشروع
                        الاستثماري المقام بناء علي غش أو تدليس أو فساد بالحماية أو الضمانات
                        أو المزايا أو الإعفاءات المقررة بموجب أحكام هذا القانون، ويكون إثبات
                        ذلك كله بموجب حكم قضائي بات صادر من القضاء المختص أو بحكم تحكيم.
                    </li>
                    <li>
                        تكون جميع القرارات المتعلقة بشئون المشروع الإستثماري مسببة، ويخطر
                        ذوو الشأن بها.
                    </li>
                    <li>لا يجوز تأميم المشروعات الاستثمارية.</li>
                    <li>
                        لا يجوز نزع ملكية أموال المشروعات الاستثمارية إلا للمنفعة العامة،
                        وبمقابل تعويض عادل يدفع مقدماً دون تأخير، وتكون قيمته معادلة للقيمة
                        الإقتصادية العادلة للمال المنزوع ملكيته في اليوم السابق علي صدور
                        قرار نزع الملكية، وتكون التعويضات قابلة للتحويل دون قيد.
                    </li>
                    <li>
                        لا يجوز بالطريق الإداري فرض الحراسة علي تلك المشروعات، ولا تفرض
                        الحراسة عليها إلا بموجب حكم قضائي نهائي، كما لا يجوز التحفظ عليها
                        إلا بموجب أمر أو حكم قضائي ، ولا يكون ذلك كله إلا في الأحوال المبينة
                        في القانون.
                    </li>
                    <li>
                        لا يجوز الحجز علي أموال المشروعات الاستثمارية أو مصادرتها أو تجميدها
                        إلا بناءً علي أمر قضائي أو حكم نهائي، وذلك عدا الديون الضريبية،
                        واشتراكات التأمينات الاجتماعية المستحقة للدولة التي يجوز تحصيلها عن
                        طريق الحجز بجميع أنواعه، مع عدم الاخلال بما يتفق عليه في العقود التي
                        تبرمها الدولة أو الأشخاص الاعتبارية العامة مع المستثمر.
                    </li>
                    <li>
                        لا يجوز لأي جهة إدارية إصدار قرارات تنظيمية عامة تضيف أعباء مالية أو
                        إجرائية تتعلق بإنشاء أو تشغيل مشروعات تخضع لأحكام هذا القانون أو فرض
                        رسوم أو مقابل خدمات عليها أو تعديلها ، إلا بعد أخذ رأي مجلس إدارة
                        الهيئة وموافقة كل من مجلس الوزراء والمجلس الأعلى للاستثمار.
                    </li>
                    <li>
                        لا يجوز للجهات الإدارية إلغاء التراخيص الصادرة للمشروع الاستثماري أو
                        وقفها أو سحب العقارات التي تم تخصيصها للمشروع إلا بعد إنذار المستثمر
                        بالمخالفات المنسوبة إليه، وسماع وجهة نظره وإعطائه مهلة مناسبة لإزالة
                        أسباب المخالفة.وفي جميع الأحوال، يجب أخذ رأي الهيئة قبل إصدار
                        القرارات المشار إليها في الفقرة الأولي، وتبدي الهيئة رأيها خلال سبعة
                        أيام من تاريخ ورود الطلب إليها مستوفياً جميع الإجراءات القانونية
                        المقررة.ويحق للمستثمر التظلم من هذا القرار أمام اللجنة المنصوص عليها
                        بالمادة "83" من هذا القانون.
                    </li>
                    <li>
                        للمستثمر الحق في إنشاء وإقامة المشروع الاستثماري وتوسيعه، وتمويله من
                        الخارج دون قيود وبالعملة الأجنبية، كما يكون من حقه تملكه وإدارته
                        واستخدامه والتصرف فيه وجنى أرباحه وتحويلها إلى الخارج وتصفية المشروع
                        وتحويل ناتج هذه التصفية كله أو بعضه إلى الخارج وذلك دون الإخلال
                        بحقوق الغير.
                    </li>
                    <li>
                        تسمح الدولة بإتاحة جميع عمليات التحويل النقدي المتصل بالاستثمار
                        الاجنبي بحرية وبدون إبطاء إلي أراضيها وخارجها، بعملة قابلة للتحويل
                        الحر كما تسمح الدولة بتحويل العملة المحلية إلي عملة قابلة للاستخدام
                        بحرية دون تأخير.
                    </li>
                    <li>
                        فى حالة التصفية تلتزم الجهات الإدارية المختصة بإخطار الهيئة والشركة
                        تحت التصفية ببيان ما عليها من التزامات خلال مدة اقصاها مائة وعشرون
                        يوما تبدأ من تاريخ تقديم المصفى طلبا بذلك مرفقا به المستندات اللازمة
                        ويعتبر انقضاء هذه المدة دون بيان تلك الالتزامات إبراء لذمة الشركات
                        تحت التصفية وذلك دون الاخلال بالمسئولية الجنائية والتأديبية للمسئول
                        عن إصدار بيان على خلاف الواقع أو من تسبب فى فوات الميعاد المشار إليه
                        دون الرد على الطلب.
                    </li>
                    <li>
                        مع عدم الإخلال بأحكام القوانيين واللوائح والقرارات المنظمة
                        للإستيراد، يحق للمشروعات الاستثمارية الخاضعة لأحكام هذا القانون أن
                        تستورد بذاتها أو عن طريق الغير، ما تحتاج إليه فى إنشائها أو التوسع
                        فيها أو تشغيلها من المواد الخام ومستلزمات الانتاج والآلات وقطع
                        الغيار ووسائل النقل المناسبة لطبيعة نشاطها، دون حاجه لقيدها في سجل
                        المستوردين.
                    </li>
                    <li>
                        يحق للمشروعات الاستثمارية الخاضعة لأحكام هذا القانون أن تصدر منتجاتها
                        بالذات أو بالوساطة دون ترخيص وبغير حاجة لقيدها فى سجل المصدرين .
                    </li>
                    <li>
                        للمشروع الاستثماري الحق في استخدام عاملين أجانب فى حدود نسبة (10%)من
                        إجمالي عدد العاملين بالمشروع، وتجوز زيادة هذه النسبة إلى مالا يزيد
                        على (20%) من إجمالي عدد العاملين بالمشروع ، وذلك فى حالة عدم إمكانية
                        استخدام عمالة وطنية تملك المؤهلات اللازمة ، ويجوز في بعض المشروعات
                        الاستراتيجية ذات الأهمية الخاصة التى يصدر بتحديدها قرار من المجلس
                        الأعلى للاستثمار الاستثناء من النسب المشار إليها بشرط مراعاة تدريب
                        العمالة الوطنية .
                    </li>
                    <li>
                        للعاملين الأجانب فى المشروع الاستثماري الحق فى تحويل مستحقاتهم
                        المالية كلها أو بعضها إلى الخارج.
                    </li>
                </ol>

                <div style="
            background-color: var(--color-gafi-border);
            border-right: 5px var(--color-primary) solid;
          " class="mb-4">
                    <p style="font-size: 16px; color: var(--color-gray-444)" class="p-2">
                        ثانيا :حوافز الاستثمار
                    </p>
                </div>

                <h5>(أ): الحوافز العامة :</h5>
                <p>
                    تتمتع بها جميع المشروعات الخاضعة لأحكام هذا القانون ، وذلك فيما عدا
                    المشروعات المقامة بنظام المناطق الحرة وهى :
                </p>
                <ol>
                    <li>
                        تعفى من ضريبة الدمغة ومن رسوم التوثيق والشهر عقود تأسيس الشركات
                        والمنشآت وعقود التسهيلات الإئتمانية والرهن المرتبطة بأعمالها، وذلك
                        لمدة خمس سنوات من تاريخ قيدها فى السجل التجاري .
                    </li>
                    <li>
                        تعفى من الضريبة والرسوم المشار إليها عقود تسجيل الأراضي اللازمة
                        لإقامة الشركات والمنشآت .
                    </li>
                    <li>
                        تسرى على الشركات والمنشآت الخاضعة لأحكام هذا القانون أحكام المادة
                        (4) من قانون تنظيم الإعفاءات الجمركية الصادرة بالقانون رقم 186 لسنة
                        1986 [1] الخاصة بتحصيل ضريبة جمركية بفئة موحدة مقدارها (2%) اثنان
                        بالمائة من القيمة ، وذلك على جميع ما تستورده من آلات ومعدات وأجهزة
                        لازمة لإنشائها ، كما تسرى هذة الفئة الموحدة على جميع ما تستورده
                        الشركات والمنشآت التى تعمل فى مشروعات المرافق العامة ، من آلات
                        ومعدات وأجهزة لازمة لإنشائها أو إستكمالها.
                    </li>
                    <li>
                        مع عدم الإخلال بأحكام الافراج المؤقت المنصوص عليها فى قانون الجمارك
                        الصادر بالقانون رقم 66 لسنة 1963[1]، يكون للمشروعات الاستثمارية ذات
                        الطبيعة الصناعية الخاضعة لأحكام هذا القانون استيراد القوالب
                        والأسطمبات وغيرها من مستلزمات الإنتاج ذات الطبيعة المماثلة دون رسوم
                        جمركية وذلك لاستخدامها فترة مؤقتة فى تصنيع منتجاتها، وإعادة تصديرها
                        إلى الخارج، ويكون الإفراج والإعادة إلى الخارج بموجب مستندات الوصول،
                        على أن تسجل مستندات الدخول وإعادة الشحن فى سجلات تعد لهذا الغرض
                        بالهيئة وذلك بالتنسيق مع وزارة المالية.
                    </li>
                </ol>
                <p class="small text-muted">
                    *صدر قانون الجمارك رقم 207 لسنة 2020 بتاريخ 11/11/2020 وعمل به بتاريخ
                    12/11/2020 , ونصت المادة الخامسة من مواد إصداره على الغاء قانون تنظيم
                    الإعفاءات الجمركية الصادر بقرار رئيس الجمهورية بالقانون رقم 186 لسنة
                    1986 .
                    <br />
                    *صدر قانون الجمارك رقم 207 لسنة 2020 بتاريخ 11/11/2020 وعمل به بتاريخ
                    12/11/2020 , ونصت المادة الخامسة من مواد إصداره على الغاء قانون
                    الجمارك الصادر بقرار رئيس الجمهورية بالقانون رقم 66 لسنة 1963 .
                </p>

                <h5>(ب): الحوافز الخاصة :</h5>
                <p>
                    تمنح المشروعات الاستثمارية التي تقام بعد العمل بهذا القانون وفقا
                    للخريطة الاستثمارية , حافزا استثماريا خصما من صافى الأرباح الخاضعة
                    للضريبة, على النحو الآتى :
                </p>

                <h6>1- نسبة (50%) خصما من التكاليف الاستثمارية للقطاع (أ):</h6>
                <p>
                    ويشمل المناطق الجغرافية الأكثر احتياجا للتنمية طبقا للخريطة
                    الاستثمارية وبناء على البيانات والإحصاءات الصادرة من الجهاز المركزى
                    للتعبئة العامة والاحصاء , المعتمدة بالخطة العامة للتنمية الاقتصادية
                    والاجتماعية ووفقا لتوزيع أنشطة الاستثمار بها على النحو الذى تبنية
                    اللائحة التنفيذية لهذا القانون .
                </p>

                <h6>2- نسبة (30%) خصما من التكاليف الاستثمارية للقطاع (ب):</h6>
                <p>
                    ويشمل باقى انحاء الجمهورية وفقا لتوزيع انشطة الاستثمار, وذلك للمشروعات
                    الاستثمارية الآتية:
                </p>
                <ul>
                    <li>
                        المشروعات كثيفة الاستخدام للعمالة وفقا للضوابط المنصوص عليها فى
                        اللائحة التنفيذية لهذا القانون.
                    </li>
                    <li>المشروعات المتوسطة والصغيرة</li>
                    <li>المشروعات التى تعتمد على الطاقة المتجددة أو تنتجها</li>
                    <li>
                        المشروعات القومية والاستراتيجية التى يصدرها قرار من المجلس الأعلى
                        للاستثمار
                    </li>
                    <li>
                        المشروعات السياحية التى يصدرها قرار من المجلس الأعلى للاستثمار
                    </li>
                    <li>
                        مشروعات إنتاج الكهرباء , وتوزيعها التى تصدر بتحديدها قرار من رئيس
                        مجلس الوزراء بناء على عرض مشترك من الوزير المختص والوزير المعنى
                        بشئون الكهرباء ووزير المالية .
                    </li>
                    <li>
                        المشروعات التى يصدر إنتاجها إلى الخارج الإقليم الجغرافى لجمهورية مصر
                        العربية
                    </li>
                    <li>صناعة السيارات والصناعات المغذية لها</li>
                    <li>
                        الصناعات الخشبية والأثاث والطباعة والتغليف والصناعات الكيماوية
                    </li>
                    <li>صناعات المضادات الحيوية وأدوية الأورام ومستحضرات التجميل</li>
                    <li>
                        الصناعات الغذائية والحاصلات الزراعية وتدوير المخلفات الزراعية
                    </li>
                    <li>الصناعات الهندسية والمعدنية والنسيجية والجلود</li>
                </ul>

                <p>
                    وفى جميع الاحوال يجب الايجاوز الحافز الاستثمارى(80%) من رأس المال
                    المدفوع حتى تاريخ بدء مزاولة النشاط وذلك فقا لأحكام قانون الضريبة على
                    الدخل الصادر بالقانون رقم 91لسنة 2005 , كما يجب الاتزيد مدة الخصم على
                    سبع سنوات من تاريخ بدء مزاولة النشاط
                </p>
                <div class="faq-container py-5">
                    <p>أدلة التراخيص </p>
                    <div class="faq-item" *ngFor="let item of items">
                        <div class="faq-header" (click)="toggle(item)">
                            <div class="indicator" [class.expanded]="item.expanded">
                                <i class="fa-solid" [class.fa-minus]="item.expanded"
                                    [class.fa-plus]="!item.expanded"></i>
                            </div>
                            <div class="title">{{ item.title }}</div>
                        </div>
                        <div class="faq-content" *ngIf="item.expanded">
                            <ul class="list-unstyled mb-0 px-3 py-2">
                                <li *ngFor="let file of item.files" class="mb-2 border-bottom pb-2">
                                    <ng-container *ngIf="file.url; else noLink">
                                        <a [href]="file.url" target="_blank"
                                            class="text-decoration-none d-flex align-items-center"
                                            style="color: var(--color-primary);">
                                            <i class="fa-regular fa-file-pdf text-danger ms-2"></i>
                                            <span>{{ file.name }}</span>
                                        </a>
                                    </ng-container>
                                    <ng-template #noLink>
                                        <div class="d-flex align-items-center">
                                            <span class="ms-2 text-muted">-</span>
                                            <span class="text-muted">{{ file.name }}</span>
                                        </div>
                                    </ng-template>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <app-fixed-go-on></app-fixed-go-on>
            </div>
        </div>
    </div>
</div>